<template>
  <el-form
    label-position="top"
    ref="form"
    :model="form"
    size="medium">
    <el-form-item>
      <span>使用其他批次</span>
      <el-switch
        v-model="isSelectBatch">
      </el-switch>
    </el-form-item>
    <div v-if="isSelectBatch">
      <el-form-item>
        <remote-select
          v-model="form.customerId"
          @change="customerChange"
          placeholder="请输入客户关键字"
          :query-request="getCustomerTable"/>
      </el-form-item>
      <el-form-item>
        <remote-select
          v-model="form.projectId"
          @change="projectIChange"
          :disabled="!form.customerId"
          placeholder="请输入项目关键字"
          :query-request="(_)=>getProjectTable(Object.assign(_, {customerid: form.customerId}))"/>
      </el-form-item>
      <el-form-item>
        <remote-select
          v-model="form.batchId"
          :disabled="!form.projectId"
          placeholder="请输入批次关键字"
          @change="batchChange"
          label-key="detail"
          id-key="number"
          :query-request="(_)=>getBatchTable(Object.assign(_, {projectid: form.projectId}))"/>
      </el-form-item>
    </div>
    <el-form-item label="配置信息条目">
      <div
        style="margin-bottom: 10px;"
        v-for="(item, index) in form.messages"
        :key="index">
        <el-input v-model="form.messages[index]"
                  style="width: 300px;"
                  placeholder="请输入题目审核不通过信息"
                  @focus="() => focusItem(index)"
                  @blur="() => blurItem(index)"></el-input>
        <el-button
          :disabled="form.messages.length === index + 1"
          size="medium"
          type="danger"
          icon="el-icon-delete"
          @click="removeItem(index)"></el-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  components: {},
  props: {
    batchId: [String, Number],
  },
  data () {
    return {
      isSelectBatch: false,
      form: {
        customerId: null,
        projectId: null,
        batchId: null,
        messages: [''],
      },
    }
  },
  computed: {},
  watch: {},
  created () {
    this.onLoad()
  },
  mounted () {},
  methods: {
    ...request.map([
      'getCustomerTable',
      'getProjectTable',
      'getBatchTable',
    ]),
    onLoad () {
      return this.setForm(this.batchId)
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      return this.onLoad()
    },
    setForm (batchId) {
      this.loading = true
      return request.alert('getQuestionNotPassMessageDetail', {batch_id: batchId}).then(({data}) => {
        if (data) {
          this.form.messages = data.error_msg || []
          this.form.messages.push('')
        }
      })
    },
    getForm () {
      let form = {}
      form.batch_id = this.batchId
      form.error_msg = _.filter(this.form.messages)
      return form
    },
    onSubmit () {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid) => {
          let form = this.getForm()
          if (valid && form.error_msg.length) {
            request.alert('saveQuestionNotPassMessageData', form).then((res) => {
              this.$message.success('保存成功！')
              resolve(form.error_msg)
            }, reject)
          } else {
            this.$message.error('提交内容填写不正确！')
            reject(Error('提交内容填写不正确！'))
          }
        })
      })
    },
    removeItem (index) {
      this.form.messages.splice(index, 1)
    },
    focusItem (index) {
      let messages = this.form.messages
      if (!messages[index] && messages.length === index + 1) {
        this.form.messages.push('')
      }
    },
    blurItem (index) {
      let messages = this.form.messages
      if (!messages[index] && messages.length === index + 2) {
        messages.splice(index + 1, 1)
      }
    },
    customerChange () {
      this.form.batchId = null
      this.form.projectId = null
    },
    projectIChange () {
      this.form.batchId = null
    },
    batchChange (val) {
      if (val.id) {
        this.setForm(val.id)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-error-message/components/QuestionErrorMessageForm.vue